import React, { useState } from 'react';
import './index.css';
import logo from './imgs/CONNCEPTS-LOGO-test.png';

const links = [
  { href: '/why-me', label: 'Why me' },
  { href: '/customizations', label: 'Customizations' },
  { href: '/integrations', label: 'Integrations' },
  { href: '/utilities', label: 'Free tools' },
  { href: '/pricing', label: 'Pricing' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const path = window.location.pathname.toLowerCase();

  return (
    <header className="site-header">
      <div className="beta-banner">
        <span className="beta-banner-tag">Beta</span>
        <span>
          <a href="https://www.erpulse.net" target="_blank" rel="noopener noreferrer" className="beta-banner-link">ERPulse</a>
          {' '}gives you real-time monitoring for Epicor.
        </span>
        <a href="https://www.erpulse.net" target="_blank" rel="noopener noreferrer" className="beta-banner-cta">Take a look</a>
      </div>

      <nav className="nav-bar" aria-label="Main">
        <div className="nav-inner">
          <a href="/" className="nav-logo">
            <img src={logo} alt="Conncepts home" />
          </a>

          <div className="nav-links">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="nav-link"
                aria-current={path === l.href ? 'page' : undefined}
              >
                {l.label}
              </a>
            ))}
            <a href="/contact" className="nav-link-cta">Book a call</a>
          </div>

          <button
            className="nav-mobile-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
          >
            <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7h16M4 12h16M4 17h16" />
              )}
            </svg>
          </button>
        </div>

        {isMenuOpen && (
          <div className="nav-mobile-menu">
            <a href="/" className="nav-mobile-link">Home</a>
            {links.map((l) => (
              <a key={l.href} href={l.href} className="nav-mobile-link">{l.label}</a>
            ))}
            <a href="/contact" className="nav-mobile-link nav-mobile-cta">Book a call</a>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
